<div class="cards-container">
  <loading [isLoading]="isLoading" [isFullSize]="true"></loading>

  <div class="col-3 margin-right-5 massive-load-card">
    <h3 matTooltip="Sólo se agregaran los vines del cliente principal">Carga Masiva</h3>
    <mat-card>
      <!-- Coloca el div de los archivos al final usando flexbox -->
      <div class="file-buttons">
          <div class="row row-cm">
            <div class="col-4 margin-right-5">
              <a (click)="exportToExcel('Plantilla_Asignacion_VINS')">
              <img class="icon" src="/assets/img/download.png" /></a>
            </div>
            <div class="col-8">
              <label class="custom-file-label" (click)="exportToExcel('Plantilla_Asignacion_VINS')">
                Descargar plantilla
              </label>
            </div>
          </div>
          <div class="row row-cm">
            <div class="col-4 margin-right-5">
              <input
                [id]="'fileInput_' + clientNumber"
                mat-button
                type="file"
                style="display: none;"
                (change)="updateFileInput($event)"
            />
            <label [for]="'fileInput_' + clientNumber">
                <img class="icon" src="/assets/img/upload.png"/>
            </label>
            </div>
            <div class="col-8">
              <label [for]="'fileInput_' + clientNumber" class="custom-file-label">
                Cargar plantilla
              </label>
            </div>
          </div>
          <div class="row row-cm">
            <div class="col-12">Seleccionado:</div>
          </div>
          <div class="row row-cm">
            <div class="col-12 fileName">{{fileName}}</div>
          </div>
            <button matTooltip="Sólo se agregaran los vines del cliente principal" class="col-12" mat-button (click)="sendFileInput($event)">
              Cargar Plantilla
            </button>
      </div>
    </mat-card>
  </div>

  <div class="col-8">
    <h3 matTooltip="Sólo se agregaran los vines del cliente principal">Carga Manual</h3>
    <mat-card class="autocomplete-card">
      <div class="card-content">
        <div class="col-12 selected-list-filter">
        <mat-form-field class="input_code">
          <mat-label>{{placeHolder}}</mat-label>
          <input
            type="text"
            placeholder="Ingrese un identificador"
            matInput
            [formControl]="myControl"
            [matAutocomplete]="auto"
            #autocompleteInput
            (click)="setFilteredOptions()"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.identifier"
            >
              {{option.identifier}} {{option.description ? ' - ' + option.description : ''}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
          <button class="button-add" matTooltip="Sólo se agregaran los vines del cliente principal" mat-button matSuffix (click)="addSelectedItem($event)">
            Agregar
          </button>
          <button class="button-delete" matTooltip="Se eliminaran todos los vines" mat-button matSuffix (click)="deleteAllItems($event)">
            Borrar todos
          </button>
      </div>
      <div class="col-12 selected-list-filter">
        <div class="col-8 selected-list-filter">
            <button class="button-add" matTooltip="Sólo se agregaran los vines del cliente principal" mat-button matSuffix (click)="addAllSelectedItem($event)">
              Agregar todos de los grupos seleccionados
            </button>
        </div>
      </div>
    </div>

      <mat-card-title *ngIf="isSelectedItems"> {{selectedItems.length}} {{ selectedItemsLabel }}</mat-card-title>
      <mat-card-content>
        <div class="selected-list-container">
          <mat-list class="selected-list">
            <mat-list-item
              *ngFor="let item of selectedItems"
              class="custom-card minimalist-font"
            >
            <div class="checkbox-spacing">
              <div class="selected-item-text">
                {{ item.identifier }}
              </div>
              <a>
                <span class="custom-x" (click)="onItemChange(item)">X</span>
              </a>
              <!-- <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="onItemChange(item)"
              ></mat-checkbox> -->
            </div>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-card-content>
      
    </mat-card>
  </div>
</div>
